import { enhancedApi as generatedApi } from './generated/printableFilevineSectionsService';

// Export the generated hooks
export const {
  usePrintableFilevineSectionsListQuery,
  usePrintableFilevineSectionsCreateMutation,
  usePrintableFilevineSectionsDestroyMutation,
  usePrintableFilevineSectionsUpdateMutation,
  usePrintableFilevineSectionsPartialUpdateMutation,
} = generatedApi;

// Export types
export type {
  CreatePrintableFilevineSectionSchema,
  PrintableFilevineSectionSchema,
  UpdatePrintableFilevineSectionSchema,
} from './generated/printableFilevineSectionsService';
